// app/javascript/google_tag_manager.js
export function initializeGTM() {
  const gtmId = 'GTM-N5347KM'; // Replace with your actual GTM ID
  window.dataLayer = window.dataLayer || [];
  window.gtmLoaded = false; // Flag to indicate GTM has loaded

  function gtmLoadedCallback() {
    window.gtmLoaded = true; // Set flag to true when GTM is loaded
    window.dispatchEvent(new Event('gtm:load')); // Dispatch the event
  }

  // GTM initialization code
  (function (w, d, s, l, i) {
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    j.onload = gtmLoadedCallback; // Set the onload callback
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);
}